var _path, _path2, _path3, _path4, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCausaparada(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5885 29.929C35.4483 30.7888 35.4483 32.1846 34.5885 33.0444C33.7286 33.9043 32.335 33.9043 31.473 33.0444L21.8726 23.4439C21.0127 22.5841 21.0127 21.1884 21.8726 20.3285C22.7324 19.4686 24.126 19.4686 24.9859 20.3285L34.5885 29.929Z",
    fill: "white",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56991 21.6353C12.6045 25.6699 19.1467 25.6699 23.1813 21.6353C27.216 17.6007 27.216 11.0585 23.1813 7.02596C19.1467 2.99135 12.6045 2.99135 8.56991 7.02596C4.53529 11.0606 4.53529 17.6028 8.56991 21.6374V21.6353Z",
    fill: "#F5FBFA",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5498 30.2044C37.8756 31.5302 37.8756 33.6799 36.5498 35.0057C35.224 36.3315 33.0743 36.3315 31.7485 35.0057L25.9751 29.2322C24.6493 27.9064 24.6493 25.7568 25.9751 24.4309C27.3009 23.1051 29.4506 23.1051 30.7764 24.4309L36.5498 30.2065V30.2044Z",
    fill: "#F9839A",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 14.9385H8.04063L10.3767 9.2074L13.3142 19.4559C13.257 19.3225 14.2249 14.5954 14.2249 14.5954L20.6697 14.5403",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 14.5,
    r: 3,
    fill: "#F9839A",
    stroke: "#228C80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCausaparada);
export default __webpack_public_path__ + "static/media/Ic_causa parada.dbfef36dea77e5bbc21f8cd73ae17751.svg";
export { ForwardRef as ReactComponent };